import { AbiFunction } from 'ox';
import { erc20Functions } from '../../abi.js';
import { hex } from '../../utils.js';
export async function getErc20Allowance(rpc, token, owner, spender) {
    const data = AbiFunction.encodeData(erc20Functions.allowance, [hex(owner), hex(spender)]);
    const raw = await rpc.ethCall(token, data);
    return AbiFunction.decodeResult(erc20Functions.allowance, hex(raw));
}
